<script setup>
import BottomSheet from './BottomSheet.vue';
import ButtonComponent from './ButtonComponent.vue';
import { useScreenSize } from '@/composables/useScreenSize';
import { computed } from 'vue';
const { screenSize } = useScreenSize();

const isMobile = computed(() => screenSize.value === 'mobile');

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['close']);
</script>

<template>
  <BottomSheet
    :visible="visible"
    :close-icon-right-align="true"
    max-width="max-w-[400px]"
    min-height="min-h-[0px]"
    @close="$emit('close')"
  >
    <div class="flex flex-col items-center justify-start gap-4">
      <img
        width="60"
        src="@/assets/warning-icon.svg"
      />
      <p
        class="justify-start self-stretch p-4 text-center text-sm font-normal leading-tight tracking-tight text-steel-700"
      >
        These credentials already exist in our system.
      </p>
      <p
        class="justify-start self-stretch px-4 text-center text-sm font-normal leading-tight tracking-tight text-steel-700"
      >
        Please double check your credentials or contact
        <a
          class="font-medium text-sun-700 underline hover:text-sun-800 active:text-sun-900"
          href="mailto:eldservice@highway.com"
        >
          eldservice@highway.com
        </a>
        for further assitance.
      </p>
      <div
        class="mt-4 flex w-full"
        :class="{ 'justify-end': !isMobile }"
      >
        <ButtonComponent
          variant="primary"
          @click="$emit('close')"
          :height="isMobile ? 'h-12 w-full' : 'h-9'"
        >
          Ok
        </ButtonComponent>
      </div>
    </div>
  </BottomSheet>
</template>

<style lang="scss" scoped></style>
